import axios from 'axios';
import Swal from 'sweetalert2';
import { store } from '../App';
import { LOGIN_DOMAIN } from './Configuration';

const axiosTokenService = axios.create();
const disableBackButton = () => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function(event) {
        window.history.go(1);
    };
};
axiosTokenService.interceptors.response.use(async (config) => { 
    return config;
}, function (error) {
    store.dispatch({ type: "HIDE_SPINNER" });
    if (error?.response?.status === 401) {
        disableBackButton();
        Swal.fire({
            icon: 'error',
            title: 'Session Expired',
            confirmButtonText: 'OK',
            allowOutsideClick: false, 
        allowEscapeKey: false 
        }).then((result) => {
            if (result.isConfirmed) {
             window.location.href=LOGIN_DOMAIN
            }
        })
    }
   else if (error?.response?.status === 400) {
    const errorMessage = error?.response?.data?.message || error?.response?.data || "An error occurred.";
        Swal.fire({
            icon: 'error',
            text: errorMessage,
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false
        })
      }

      else if (error?.response?.status === 404) {
        const errorMessage = error?.response?.data?.message || 'Resource not found';
    
        Swal.fire({
            icon: 'error',
            title: 'Not Found',
            text: errorMessage, // Show API-provided message
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false
        }).then((result) => {
            if (result.isConfirmed) {
                // window.location.href = LOGIN_DOMAIN;
            }
        });
    }
    
    
    else if (error?.response?.status === 500) {
    }
    return Promise.reject(error);
});

axiosTokenService.interceptors.request.use(async (config) => { //changes by amman
    const token = "Bearer" +' '+ localStorage?.getItem("token").replace(/['"]+/g, '');  
    config.headers.Authorization = token;
    return config;
}, function (error) {
    store.dispatch({ type: "HIDE_SPINNER" });
    if (error?.response?.status === 401) {
        disableBackButton();
        Swal.fire({
            icon: 'error',
            title: 'Session Expired',
            confirmButtonText: 'OK',
            allowOutsideClick: false, 
        allowEscapeKey: false 
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href=LOGIN_DOMAIN
            }
        })
    }else if (error?.response?.status === 500) {
     }
    return Promise.reject(error);
});

export default axiosTokenService;
